module.exports = __webpack_public_path__ + "static/media/checkmark.37d10997.svg";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/checkmark.svg
// module id = 94
// module chunks = 0